module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/particular06-9758ccbb82b8fb52b47801d919b9437f.png";